/* istanbul ignore file */

import { get, uniq, isEmpty } from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { getTargetConstraints, getCountriesLocations } from '../common/deal-constraints';

export const fillLocationForDeal = async (deal, serverContext) => {
  if (!deal) {
    return Promise.resolve();
  }
  const locationIds = getTargetConstraints(deal, 'Location').mandatory;

  const cid = serverContext.CurrentCustomer.Id;
  const aid = serverContext.CurrentAccount.Id;
  const lcid = serverContext ? serverContext.CurrentUser.LocaleID : '1033';

  const responses = await getCountriesLocations(locationIds, lcid, cid, aid);
  const CountryName = uniq(responses.map(res => res.data.EnglishName)).join(',');
  return {
    ...deal,
    CountryName,
  };
};

export const getDealDetails = async (cid, aid, campaignId, serverContext) => {
  try {
    const targets = await edmCampaign
      .Customers.$withKey(cid)
      .Accounts.$withKey(aid)
      .Campaigns.$withKey(campaignId)
      .CampaignCriterions.$cast('Model.CampaignCriterion')
      .get({
        filter: {
          where: "isof(Criterion,'Model.DealCriterion')",
        },
      })
      .toPromise();

    const dealId = get(targets, 'value[0].Criterion.DealId');

    if (!dealId) {
      return Promise.resolve();
    }

    try {
      const dealDetail = await edmCampaign
        .Customers.$withKey(cid)
        .Accounts.$withKey(aid)
        .Deals.$withKey(targets.value[0].Criterion.DealId)
        .get()
        .toPromise();

      if (serverContext) {
        const filledDeal = await fillLocationForDeal(dealDetail, serverContext);
        return filledDeal;
      }
      return dealDetail;
    } catch (error) {
      console.error(error);
      // If we get an error with errorCode InvalidId,
      // we will return the dealId and the error code as it is deleted by Xandr.
      const errorCodeTarget = GetDealErrorCode(error, 'InvalidId');
      if (errorCodeTarget) {
        return Promise.resolve({
          Id: dealId,
          Error: errorCodeTarget,
        });
      }
      return Promise.resolve();
    }
  } catch (error) {
    console.error(error);
    return Promise.resolve();
  }
};

const GetDealErrorCode = (error, expectedError) => {
  if (error.status !== 400) {
    return null;
  }

  const responseErrArray = get(error, ['responseJSON', 'value']);
  if (isEmpty(responseErrArray)) {
    return null;
  }

  if (get(responseErrArray, [0, 'Code']) === expectedError) {
    return expectedError;
  }
  return null;
};
